import React from 'react';
import { useBrand } from '../../../app/config/brand';
import { Card } from '../../../shared/components/ui/Card';
import { Button } from '../../../shared/components/ui/Button';
import { useMcpConfig } from '../hooks/useMcpConfig';

interface McpNudgeCardProps {
  onNavigate: (page: string) => void;
}

/**
 * Dashboard nudge card pointing customers at /settings/integrations. Part of the
 * config-gated discoverability surface: returns null while the MCP server is
 * dark (R-CONFIG-GATE) and carries the boundary disclaimer so it holds wherever
 * the surface renders (R-DISCLAIMER).
 */
const McpNudgeCard: React.FC<McpNudgeCardProps> = ({ onNavigate }) => {
  const brand = useBrand();
  const { enabled } = useMcpConfig();

  if (!enabled) return null;

  return (
    <div data-testid="mcp-nudge-card">
      <Card>
        <div className="flex items-center justify-between gap-4">
          <div>
            <div className="font-semibold mb-1" style={{ color: brand.colors.secondary }}>
              Connect a Claude client
            </div>
            <p className="text-sm" style={{ color: brand.colors.textLight }}>
              Prepare and review filings from Claude Code or claude.ai. Final court submission and
              payments stay in the portal.
            </p>
          </div>
          {/* Single-line, label-sized, vertically centered (Walter R31) — the
              flex default let this shrink into a circle that wrapped "Set up"
              onto two lines. */}
          <Button
            size="sm"
            className="shrink-0 whitespace-nowrap"
            onClick={() => onNavigate('settings/integrations')}
          >
            Set up
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default McpNudgeCard;
